// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__33Atp","calendarButtons":"ClockData_calendarButtons__15QB5"};